<template>
  <div class="sized-cell-wrapper" :class="{ 'allow-overflow': allowOverflow }">
    <slot/>
  </div>
</template>

<script setup>
const props = defineProps(['allowOverflow'])
</script>

<style scoped lang="scss">
  .sized-cell-wrapper {
    overflow: hidden auto;
    height: 120px;
  }

  // used for "floating" thumbnails that extend slightly beyond the bounds of the cell wrapper
  .allow-overflow {
    overflow: visible;
  }
</style>
